
<style>

  .center {
      margin-left: auto;
      margin-right: auto;
      display: block;
      height:200px;
      width: 600px;
  }
  .centerdiv {
      margin-left: auto;
      margin-right: auto;
      display: block;
      text-align: center;
      background-color: black;
  }
  .backgroundDiv{
    text-align: center;
  opacity: 0.9;
  }
  </style>
   
   
  
  <nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
    <!-- Left navbar links -->
   

    <!-- Right navbar links -->
    <ul class="navbar-nav lg-auto"  >
     
        <li class="nav-item" *ngIf="ocultarCarrito == false" >
          <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
            <i class="fas fa-bars" style="font-size: 34px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
          </a>
        </li>
 
      

      <!-- Navbar Search -->
      <li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
          <i class="fas fa-search"style="font-size: 32px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
        </a>
        <div class="navbar-search-block" >
          <form class="form-inline"  [formGroup]="formBuscar" >
            <div class="input-group input-group-sm" >
              <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: 20pt;height: 48px;border: 2px solid #0A0A0A; color: #0b0b0b;font-weight: bold;background-color: #FFFFFF;;height: 52px;" formControlName="txtBuscar" (keyup.enter)="OnBuscarAll()" >
              <div class="input-group-append">
                <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()"   style="border: 2px solid #424949;"  >
                  <i class="fas fa-search" style="font-size: 36px;"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                  <i class="fas fa-times" style="font-size: 36px;"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>

    

    </ul>
    
   
    
    <ul    class="navbar-nav ml-auto">
      <li  class="nav-item" >
    
        <div >
          <img src="./assets/dist/img/titulo_andrea.png"  width="150" height="35" />
         </div>
   
      
      </li>  

    </ul>

    <ul    class="navbar-nav ml-auto">

      



      <li  class="nav-item dropdown" *ngIf="tieneSession == true" >

        <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
     

            <img src="./assets/dist/img/user.png"  width="auto" height="42px" style="margin-top: -16px;margin-right: -12px;"  />

     
          
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
            
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  {{nombreCuenta}}
                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item" (click)="logout()">
            <!-- Message Start -->
            <div class="media">
             
              <div class="media-body">
                <h3 class="dropdown-item-title">
                Cerrar sesión
                  <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
         
         
          
        </div>

      </li>

      <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;margin-top: -8px;">
        <a href="#/carrito">
        <img src="./assets/dist/img/carro.png"  width="auto" height="46"   />
        </a>
      </li>
  
      <span style="color: rgb(50, 50, 50);font-size: 35px;font-weight:bold">{{CantidadItem}}</span>

        <!-- <a  href="#/carrito">
          <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
        
        </a> -->
      
    


  <!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
  {{countpedido}}   
   
</a> -->




     


     


    </ul>
   

  




  </nav>


<app-sidebar-ecomerce></app-sidebar-ecomerce>
  <div class="content-wrapper">

    <div class="content">
      <div class="container">
        <div class="row">
      
        </div>

        <div class="card card-success">
      
          <div class="col-sm-12">
           <video width="98%" height="98%" 
           controls 
           autoplay
           loop
           onloadedmetadata="this.muted=true"
           >
            <source src="./assets/dist/img/andreabanner.mp4" type="video/mp4">
           </video>
          </div>
          </div>
          <div class="card card-success">
          <div *ngIf="modoBusqueda== false">
            <div class="card-body">
             
                <div class="col-sm-12">

                  <div class="card card-warning">
                    <div class="card-header">
                      <h3 class="card-title">1. Selecciona un Pedido </h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
      
      
      
                      <div class="card-body pt-0" *ngFor="let dato of pedidoclienteDTO; let i=index">
                        <div class="row">
                          <div class="col-7">
                            <h2 class="lead" style="color:gray;"><b>Fecha: {{dato.fecha | date:'dd-MM-yyyy'}} </b></h2>
                            <table class="table">
                              <tr >
                                <td class="text-muted text-bold">No. Pedido: </td>
                                <td class="text-muted text-sm" style="text-align: center;"> {{dato.idPedido}}</td>
                              </tr>
                             
      
                              
                              <tr>
                                <td class="text-muted text-bold">Estado:</td>
                                <td class="text-muted text-sm">{{dato.estado}}</td>
                              </tr>
      
                              <tr>
                                <td class="text-muted text-bold">Total:</td>
                                <td class="text-muted text-sm" style="text-align: center;">{{dato.total | currency: 'Q'}}</td>
                              </tr>
      
                            
                            </table>
      
                          </div>
                          
                        </div>

                        <div *ngIf="pedidoSeleccionado == false">
                        <div class="text-left">
                          <a class="btn btn-sm btn-danger" (click)="OnSelectPedido(dato.idPedido)">
                          Seleccionar
                          </a>
                          
                        </div>
                      </div>

                      <div *ngIf="pedidoSeleccionado == true">
                        <div class="text-left">
                          <a class="btn btn-sm btn-danger" (click)="OnRegresar()">
                          Regresar
                          </a>
                          
                        </div>
                      </div>



                        <br>
                        <br>
                     
                      </div>
      
      
      
                    </div>
                  </div>


                  <div *ngIf="pedidoSeleccionado == true">
                  <div class="card card-success">
                    <div class="card-header">
                      <h3 class="card-title">2. Seleccione el producto que necesita cambiar. </h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
      
      
                      <div class="card-body pt-0" *ngFor="let dato of detallePedidoDTO; let i=index">
                        <div class="row">
                          <div class="col-7">
                            <h2 class="lead" style="color:gray;"><b> {{dato.modelo}}</b></h2>
                            <table class="table">
                              <tr >
                                <td class="text-muted text-bold">Cantidad: </td>
                                <td class="text-muted text-sm" style="text-align: center;"> {{dato.cantidad}}</td>
                              </tr>
                              <tr>
                                <td class="text-muted text-bold">Talla:</td>
                                <td class="text-muted text-sm">{{dato.talla}}</td>
                              </tr>
      
                              <tr>
                                <td class="text-muted text-bold">Color:</td>
                                <td class="text-muted text-sm">{{dato.colorErp}}</td>
                              </tr>
      
                              <tr>
                                <td class="text-muted text-bold">Importe:</td>
                                <td class="text-muted text-sm" style="text-align: center;">{{dato.importe | currency: 'Q'}}</td>
                              </tr>
      
                              <tr>
                                <td class="text-muted text-bold">Estado:</td>
                                <td class="text-muted text-sm">{{dato.estado}}</td>
                              </tr>
                            </table>
      
                          </div>
                          <div class="col-5 text-center">
                            <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="user-avatar" class="img-circle img-fluid" style="height: auto;width: 80%;" >
                          </div>
                        </div>
                       
                        <div class="text-left">
                          <a class="btn btn-sm btn-success" (click)="OnProductoPorCambiar(dato.idProducto,dato.precioFinal,dato.indice)">
                           Cambiar este artículo
                          </a>
                          
                        </div>
                      </div>
                      
                      
      
      
      
                    </div>
                  </div>
                </div>


                
                <div *ngIf="productoPorCambiar == true">
                  <div class="card card-danger">
                    <div class="card-header">
                      <h3 class="card-title">3. Selecciona una categoria, para eligir un producto nuevo.</h3>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
      
      
                      <div class="card-body pt-0" *ngFor="let dato of detallePedidoDTO; let i=index">
                        <div class="row">

                          <form  [formGroup]="formCambio1">

                          <div class="form-group">
                                   
                            <select class="form-control" formControlName="cmbCategoria" (change)="OnSelectCategoria()" >
                              
                              <option *ngFor="let dato of categoriadto; let i=index" value={{dato.idCategoria}}>{{dato.descripcion}}</option>
                            </select>
                          </div>
                        </form>


                          
                        </div>





                        <div class="row">
                          <div class="col-10 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos of productosdto; let i=index">
                           
                            <div class="row"  (click)="OnSelectProductoNuevo(datos.idProducto,datos.precio)">
                              <div class="text-center">
                               
                                <img class="img-fluid"
                                     src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                                     alt="User profile picture" style="height: 110%;width: 110%;">
                              </div>
                              <div class="col-8">
                                <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                                <label class="text-muted text-sm">{{datos.descripcion}}</label>
                                <p class="text-muted text-sm"><b>Precio: </b> {{datos.precio | currency: 'Q'}}</p>
                               
                              </div>
            
                            </div>
                             
                            </div>
                          </div>











                     
                      </div>
                      
                      
      
      
      
                    </div>
                  </div>
                </div>




              </div>
                    <br>
          
            </div>





            














          </div>


   
        
          

          </div>
       
      
     

 
      </div>
      <div class="content">
        <div class="container">
          <div class="row">

            <div class="card card-success">
              <div class="card-body">

            
                
                  <div class="col-12 col-sm-12" >

                    
          


            <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
          </div>
       
      </div>
    </div>
  </div>
        </div>
      </div>
    </div>

       
   
   
  </div>



<app-footer-ecomerce ></app-footer-ecomerce>

